export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14653.4f43052d.jpg";